<template lang="pug">
v-card(v-click-outside="onClickOutside")
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('AGENT.ADD_FIELD')}}
  v-card-text
    v-form(v-model="valid", ref="form")
      // tenant
      v-row.mt-4
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('AGENT.FIELD_TYPE')}}
        v-col.pa-0
          v-select(
            v-model='selectFieldType',
            outlined,
            :items='fieldTypeList',
            :rules='formRule.fieldRules',
            item-text='name',
            item-value='value',
            dense,
            required='required',
            :disabled='addBtn_loading'
            @change='closeValidation'
            )
      v-row.mt-4
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('AGENT.FIELD_NAME')}}
        v-col.pa-0
          v-text-field(
            v-model='selectFieldName',
            outlined,
            :rules='formRule.fieldRules',
            placeholder='Field name',
            dense,
            required='required',
            :disabled='addBtn_loading'
            @input='enableValidation'
          )
      v-row.mt-4
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('AGENT.SYSTEM_NAME')}}
        v-col.pa-0(cols='12')
          v-text-field(
            v-model='selectSystemName',
            outlined,
            :rules='formRule.system_nameRules',
            placeholder='System name',
            dense,
            required='required',
            :disabled='addBtn_loading'
            @input='enableValidation'
          )
      v-row(v-if="selectFieldType=='text'").mt-4
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('AGENT.DEFAULT_VALUE')}}
        v-col.pa-0
          v-text-field(
            v-model='selectFieldValue',
            outlined,
            placeholder='Default value (Optional)',
            dense,
            required='required',
            :disabled='addBtn_loading'
          )
      v-row.mt-0.mb-0
        v-col.pa-0(cols='1').d-flex.justify-start.align-center
          v-checkbox(
            v-model='isMandatory',
            dense,
            :disabled='addBtn_loading'
        )
        v-col.pa-0(cols='11').d-flex.justify-start.align-center
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('AGENT.IS_MANDATORY')}}

  div.d-flex.align-center.justify-space-between(style='background-color: #f4f4f4; width:"100%""; height:60px; margin-left:0px; margin-bottom: 0px;')
    v-btn.ml-6(
      :ripple="false",
      @click="onCancel",
      width="100",
      height="40",
      color="cancel",
      depressed,
      outlined,
      style='font-weight: 700;'
      :disabled='addBtn_loading'
    ) {{$t('GENERAL.CANCEL')}}
    v-btn.mr-6(
      :ripple="false",
      @click="onConfirm",
      width="100",
      height="40",
      color="#14C6DE",
      depressed,
      dark,
    ) 
      v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
      .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.SAVE')}}

  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
    message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
    error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
  v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
    success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
</template>

<script>
import Vue from "vue";
import messageDialog from '@/components/Dialog/redirectDialog';
import errorDialog from "@/components/Dialog/errorDialog";
import successDialog from "@/components/Dialog/successDialog";
import i18n from '/common/plugins/vue-i18n.js';


export default Vue.extend({
  props: {
  },
  components: {            
      messageDialog,
      errorDialog,
      successDialog
  },
  data() {
    return {
      hideValidationFields: true,
      fieldTypeList: [
        {name: 'Text', value: 'text'},
        {name: 'Image Upload', value: 'image_upload'},
        {name: 'Document Upload', value: 'document_upload'}
      ],
      isMandatory:false,
      selectFieldType:'text',
      selectFieldName:'',
      selectSystemName:'',
      selectFieldValue:'',
      menu: false,
      addBtn_loading:false,
      messageDialog:false,
      message:"",
      errorDialog: false,
      errorMessage: "",
      successDialog: false,
      valid: true,
      formRule: {
        fieldRules: [
          (v) => this.hideValidationFields || !!v || i18n.t('RULE.RULE_R') ,
        ],
        system_nameRules: [
          (v) => this.hideValidationFields || !!v || i18n.t('RULE.RULE_R') , // 必填
          (v) => this.hideValidationFields || /^[a-zA-Z0-9_]+$/.test(v) || i18n.t('RULE.RULE_ALPHA_NUMERIC'), // 只能輸入英文字母和數字或底線
        ],
      },
    };
  },
  async created(){
  },
  methods: {
    onClickOutside (){
      if (!this.hideValidationFields) {
        this.hideValidationFields = true;
        this.$nextTick(() => {
          this.$refs.form.validate();
        });
      }
    },
    enableValidation() {
        if (this.hideValidationFields) {
            this.hideValidationFields = false;
        }
    },
    closeValidation() {
      if (!this.hideValidationFields) {
        this.hideValidationFields = true;
        this.$nextTick(() => {
          this.$refs.form.validate();
        });
      }
    },
    updateDate(val) {
      this.selectDateText = val;
    },
    validateForm() {
      if (this.$refs.form.validate()) 
        return true;
      else 
        return false;
    },
    async onConfirm() {
      this.hideValidationFields = false
      if (this.validateForm() && !this.addBtn_loading) {
        this.addBtn_loading = true;
        let newField = {}
        if (this.selectFieldType == 'text'){
          newField = {
              'data':this.selectFieldValue,
              'data_type':this.selectFieldType,
              'field_name':this.selectFieldName,
              'system_name':this.selectSystemName,
              'is_mandatory': this.isMandatory
          };
        } else {
          newField = {
            'data':null,
            'data_type':this.selectFieldType,
            'field_name':this.selectFieldName,
            'system_name':this.selectSystemName,
            'is_mandatory': this.isMandatory
          };
        }
        this.$emit("emitUpdateAgentConfig", newField)
        this.selectFieldName='';
        this.selectSystemName='';
        this.selectFieldValue='';
        this.isMandatory=false;
        this.addBtn_loading = false;
        this.$emit("emitCloseAgentFieldDialog", false);
        this.hideValidationFields = true;
      }
      
    },
    onCancel() {
      this.selectFieldName='';
      this.selectSystemName='';
      this.selectFieldValue='';
      this.isMandatory=false;
      this.hideValidationFields = true;
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
      this.$emit("emitCloseAgentFieldDialog", false);
    },
    showMessageDialog(msg) {                
        this.messageDialog = true;
        this.message = msg;
    },
    async onEmitMessageDialog(val) {
      if(val){
        // 
      }
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
      this.addBtn_loading = false;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    async onEmitSuccessDialog() {
      this.$emit("emitUpdateSubscriptionDialog", false);
      this.successDialog = false;
    },
  },
});
</script>